module.exports = __webpack_public_path__ + "img/title-3.df3d5d9f.png";